import React from 'react';

import { FormattedMessage } from 'react-intl';

import { ResultState } from '../../../../common/ui/result-state';

import DynamicCardsLanding from './assets/dynamic-cards-landing.svg';
import { messages } from './messages';

export const Landing = (): React.JSX.Element => {
	return (
		<ResultState
			imageSrcLight={DynamicCardsLanding}
			imageSrcDark={DynamicCardsLanding}
			imageWidth={'400px'}
			imageHeight={'300px'}
			primaryText={<FormattedMessage {...messages.landingPrimary} />}
			secondaryText={<FormattedMessage {...messages.landingSecondary} />}
			testId="search-page-landing"
		/>
	);
};
